

import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../redux/store";

import useFetch from "../../../hooks/useFetch";

import { fetchComparativeData } from "../api/comparativeDashboardApi";
import { parseFinYearLabels } from "../../../common/utils/parseFinYear";


// ✅ STEP 2: setYearLabels bhi import karo
import { setYearLabels } from "../../../redux/comparativeDashSlice";

interface Props {
  reportKey: string;
  endpoint: string;
  extraParams?: Record<string, any>;
}

export const useComparativeData = ({
  reportKey,
  endpoint,
  extraParams,
}: Props) => {

  const dispatch = useDispatch();

  const callFetch = useFetch();

  const [loading, setLoading] =
    useState(false);

  // ✅ AUTH DATA
  const { decryptedData } = useSelector(
    (state: RootState) => state.authData
  );

  const {
    CompCode,
    FinYear,
    ID,
  } = decryptedData || {};

  // ✅ API CALL
  const fetchData = useCallback(async () => {

   const { yr1Label, yr2Label } = parseFinYearLabels(FinYear);
    dispatch(setYearLabels({ yr1: yr1Label, yr2: yr2Label }));

    console.log("CompCode =>", CompCode);

    console.log("FinYear =>", FinYear);

    console.log("UserID =>", ID);

    if (!CompCode || !FinYear) {

      console.log(
        "CompCode or FinYear missing"
      );

      return;
    }

    await fetchComparativeData({
      endpoint,
      reportKey,
      CompCode,
      FinYear,
      UserID: ID || 0,
      extraParams: extraParams || {},
      dispatch,
      callFetch,
      setLoading,
    });

  }, [
    endpoint,
    reportKey,
    extraParams,
    dispatch,
    callFetch,
    CompCode,
    FinYear,
    ID,
  ]);

  return {
    fetchData,
    loading,
  };
};